import React from 'react'
import styled from 'styled-components'
import { bool, string } from 'prop-types'
import { Typography, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'

const Wrapper = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

function ErrorPage({ is404, error }) {
  const { t } = useTranslation()
  const history = useHistory()

  return (
    <Wrapper>
      <Typography variant="h2" component="h1" color="secondary">
        {is404 ? `404 - ${t('pageNotFound')}` : error}
      </Typography>
      <Button variant="contained" style={{ marginTop: '1rem' }} onClick={() => history.goBack()}>
        {t('goBack')}
      </Button>
    </Wrapper>
  )
}

ErrorPage.propTypes = {
  is404: bool,
  error: string,
}

export default ErrorPage
